var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeLis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#6576FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33083_160934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6599 14.1864L23.6927 10.1058C23.2695 9.84886 22.665 10.0756 22.3627 10.6045C22.0604 11.1335 22.1511 11.7683 22.5894 12.0252L23.073 12.3123L13.3854 28.8161C12.9471 29.5567 12.7959 30.4635 13.0377 31.3703C13.2796 32.262 13.8539 32.9874 14.5944 33.4257L14.806 33.5466C15.5466 33.9849 16.4534 34.136 17.3602 33.8942C18.2519 33.6524 18.9773 33.0781 19.4156 32.3375L29.0881 15.8186L29.5718 16.1058C30.01 16.3627 30.6146 16.136 30.9168 15.6071C31.204 15.063 31.0982 14.4282 30.6599 14.1864ZM23.874 23.2695L19.0982 20.4887L23.6775 12.6751L28.4383 15.4559L23.874 23.2695Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33083_160934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.136,
    height: 24,
    fill: "white",
    transform: "translate(12.9316 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeLis);
export default __webpack_public_path__ + "static/media/PhanHeLIS.13bc7e35.svg";
export { ForwardRef as ReactComponent };